<template>
  <div class="home container">
    <div class="searchBox">
      <!--      <div class="logo"></div>-->
      <!--      <input type="text" placeholder="搜索" v-model="keyword" @focu="toSearch"  />-->

      社区运营商
      <div class="close" @close="closeFn"></div>
    </div>
    <div class="roleInfo">
    </div>
    <div class="orderType1 flexBetween">
      <!--      <div class="item">-->
      <!--        <span>500</span><br>待审核商家-->
      <!--      </div>-->
      <div class="item">
        <span>{{orderData.status_16}}</span><br>待确认订单
      </div>
      <div class="item">
        <span>{{orderData.status_27}}</span><br>待取货订单
      </div>
      <div class="item">
        <span>{{orderData.status_31}}</span><br>配送中订单
      </div>
    </div>
    <div class="orderType2 flexBetween">
      <div class="item" @click="toUrl('/allOrder')">
        <div class="imgBox">
          <img src="../../assets/images/ddpartner/allDd.png" alt="">
        </div>
        总订单
      </div>
      <div class="item" @click="toUrl('/childOrder')">
        <div class="imgBox">
          <img src="../../assets/images/ddpartner/childDd.png" alt="">
        </div>
        子订单
      </div>
      <div class="item" @click="toUrl('/setting')">
        <div class="imgBox">
          <img src="../../assets/images/ddpartner/setting.png" alt="">
        </div>
        设置
      </div>
    </div>
    <div class="orderNum m6 flexBetween">
      <div class="item">
        <span>{{orderData.get_num}}</span><br>
        今日接单量
      </div>
      <div class="item">
        <span class="red">{{orderData.finish_num}}</span><br>
        今日完成订单量
      </div>
      <div class="item">
        <span>{{orderData.amount}}</span><br>
        今日交易额
      </div>
    </div>
    <!--    <div class="orderNum flexBetween">-->
    <!--      <div class="item">-->
    <!--        <span>{{orderData.get_num}}</span><br>-->
    <!--        今日订单量（单）-->
    <!--      </div>-->
    <!--      <div class="item">-->
    <!--        <span class="green">+500</span><br>-->
    <!--        今日新增（单）-->
    <!--      </div>-->
    <!--      <div class="item">-->
    <!--        <span>500</span><br>-->
    <!--        昨日订单量（单）-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    <div class="orderNum2 flexBetween">-->
    <!--      <div class="item">-->
    <!--        <span>1500</span><br>-->
    <!--        今日订单量（单）-->
    <!--      </div>-->
    <!--      <div class="item">-->
    <!--        <span class="green">+500</span><br>-->
    <!--        今日新增（单）-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script>
  export default {
    name: "home",
    data() {
      return {
        orderData: {}
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      // 调用安卓 ios 方法 退出运营商
      closeFn(){
        if(window.hasOwnProperty('Android')){
          window.Android.closeWebView();
        }

        this.$bridge.callhandler('closureofMall',  {}, () => {
          // 处理返回数据
        });
      },
      getData() {
        this.sendHttp({
          method: 'post',
          url: `${this.orderUrl}/communityorder/indexdata`,
          data: {}
        }).then(res => {
          if (res.code == 0) {
            this.orderData = res.data;
          }
          console.log(res)
        })
      },
      //跳转订单列表
      toUrl(url) {
        this.$router.push(url);
      },
      toSearch() {
        alert(1)
      }
    }
  }
</script>

<style scoped lang="less">
  .home {
    .m6 {
      margin-top: 6px;
    }

    .orderNum2 {
      height: 87px;
      text-align: center;
      background: #fff;
      padding: 8px 14px;

      .item:first-child {
        border-right: 1px solid #F5f5f5;
      }

      .item {
        width: 50%;
        font-size: 12px;
        padding: 2px;
        color: #8D95A6;
        line-height: 26px;

        span {
          font-weight: bold;
          color: #333;
          font-size: 20px;
        }
      }
    }

    .orderNum {
      height: 87px;
      padding: 16px 30px;
      border-bottom: 1px solid #F5f5f5;
      background: #fff;

      .item {
        font-size: 12px;
        text-align: center;
        padding: 2px;
        color: #8D95A6;
        line-height: 26px;

        span {
          font-weight: bold;
          color: #333;
          font-size: 20px;

          &.red {
            color: #DE1919;
          }

          &.green {
            color: #0BB162;
          }
        }
      }
    }

    .orderType2 {
      text-align: center;
      background: #fff;
      border-radius: 2px;
      width: 347px;
      height: 80px;
      margin: 0 auto;
      margin-top: -20px;
      padding: 8px 33px;

      .imgBox {
        width: 40px;
        height: 40px;
        overflow: hidden;
        margin-bottom: 6px;
        background: #e1f0ff;
        border-radius: 50%;

        img {
          width: 100%;
        }
      }
    }

    .orderType1 {
      color: #fff;
      padding: 30px 24px;
      text-align: center;
      background: #2B5EE6;

      .item {
        line-height: 30px;

        span {
          font-size: 20px;
        }
      }
    }

    .searchBox {
      color: #fff;
      padding: 16px;
      font-size: 16px;
      text-align: center;
      background: #2C5EEB;
      position: relative;
      /*.logo{*/
      /*  width: 32px;*/
      /*  height: 32px;*/
      /*  border-radius: 50%;*/
      /*  background: #fff;*/
      /*}*/
      /*input{*/
      /*  width: 300px;*/
      /*  height: 32px;*/
      /*  border-radius: 22px;*/
      /*  background: #fff;*/
      /*  padding: 0 13px;*/
      /*}*/

      .close {
        width: 15px;
        height: 15px;
        background: url("../../assets/images/ddpartner/close.png") no-repeat;
        background-size: contain;
        position: absolute;
        top:20px;
        right: 20px;
      }
    }

  }

</style>
